import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link } from "react-router-dom";
import {
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import AssignOffCanvance from "../AssignDeliveryBoy";
import ProductModal from "../ProductModal";
import AssignReturnOffCanvance from "../AssignReturnDeliveryBoy";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";

function SentTable({
  user,
  OrderByOptions,
  resultsPerPageOptions,
  storeCategories,
  productCategories,
  vendorServices,
  statusCount,
  activeTab,
  handleTabClick,
  GetAllCounts,
  // searchOrderStatus,
  // setSearchOrderSatatus,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [searchOrderStatus, setSearchOrderSatatus] = useState(
    OrderStatusIds.OrderUnderQualityCheck
  );
  const getDataAll = async () => {
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&term=${search}&searchOrderStatus=${
        searchOrderStatus || ""
      }&storeCategory=${storeCategory}&productCategory=${
        productCategory.value || ""
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&start_time=${searchStartTime || ""}&end_time=${
        searchEndTime || ""
      }&name=${search || ""}&customer=${
        searchCustomer || ""
      }&customer_contact=${searchCustomerContact || ""}`
    );
    await setData(response);
    setCurrentPage(response?.data?.current_page);
    // setperPage(response?.data?.per_page);
    settotalPages(response?.data?.total_pages);
    setSearch(response?.data?.search_name);
    setOption(await Per_Page_Dropdown(response?.data?.totalEntries));
    // await GetAllCounts();
  };
  useEffect(() => {
    getDataAll();
  }, [
    reset,
    searchOrderStatus,
    storeCategory,
    productCategory,
    onPageChange,
    activeTab,
  ]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  
  const calculateTimeAgo = (date) => {
    const createdAt = new Date(date);
    const now = new Date();
    const diffInMilliseconds = now - createdAt;

    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));
    const diffInDays = Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24));

    if (diffInDays >= 1) {
      return `${diffInDays} Day${diffInDays > 1 ? "s" : ""} Ago`;
    } else if (diffInHours >= 1) {
      return `${diffInHours} Hour${diffInHours > 1 ? "s" : ""} Ago`;
    } else {
      return `${diffInMinutes} Min Ago`;
    }
  };

  const formatTimeInIST = (date) => {
    const createdAt = new Date(date);
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    const istTime = createdAt.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      ...options,
    });
    // setFormattedTime(`${istTime} IST`);
    return istTime;
  };

  const ChangeOrderStatus = async (id, status_id) => {
    try {
      // Send the POST request to update the store's status
      await postData(`/admin/orders/product-order/update-status/${id}`, {
        order_status_id: status_id,
      });

      setSearchOrderSatatus(status_id);
      await getDataAll();
      GetAllCounts();
    } catch (error) {
      console.error("Error updating store status:", error);
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        // await DownloadExcel(
        //   // "/download-excel/download-users",
        //   `/download-excel/download-users?term=${search || ""}&mobile=${mobile || ""}&from=${from || ""}&to=${to || ""}`,
        //   "Users List"
        // );
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            searchOrderStatus || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List"
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);
  return (
    <section className="pending-table_holder">
      <section className="pending-table_holder">
        <div className="filter-tabs-container">
          <div className="tabs">
            <button
              className={`waiting-tab ${
                activeTab === "waitingForPickup" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("waitingForPickup");
                setSearchOrderSatatus(OrderStatusIds.OrderUnderQualityCheck);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.OrderUnderQualityCheck}</span> Order under
              Quality Check
            </button>
            <button
              className={`waiting-tab ${
                activeTab === "shipped" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("shipped");
                setSearchOrderSatatus(OrderStatusIds.Pickup);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.PickupScheduled}</span> Pickup
            </button>
            <button
              className={`waiting-tab ${
                activeTab === "delivered" ? "active btn" : "btn"
              }`}
              onClick={() => {
                handleTabClick("delivered");
                setSearchOrderSatatus(OrderStatusIds.Delivered);
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.Delivered}</span> Delivered
            </button>

            {/* <button
              className={`waiting-tab ${activeTab === "OrderReturned"
                ? "active btn"
                : "btn"
                }`}
              onClick={() => {
                handleTabClick("OrderReturned");
                setSearchOrderSatatus(
                  OrderStatusIds.Returned
                );
                setonPageChange(1);
              }}
            >
              <span>{statusCount?.Returned}</span> Returned
            </button> */}
          </div>
        </div>
      </section>

      {/* Quick Filters Section */}

      <div className="quick-filters">
        {/* <span className="quick-filters__label">Quick Filters:</span> */}
        <div className="quick-filters__tabs">
          {/* <Button
            className={
              storeCategory === "" && productCategory === ""
                ? "quick-filters__tab quick-filters__tab--active"
                : "quick-filters__tab"
            }
            onClick={() => {
              setStoreCategory("");
              setProductCategory("");
              setonPageChange(1);
            }}
          >
            All Orders
          </Button> */}
          <div className="quick-filters mt-3">
            <span className="quick-filters__label">
              <b>Quick Filters:</b>
            </span>
            <div className="quick-filters__tabs mt-3">
              <div className="row">
                <div className="col-md-3">
                  <div className="num me-2">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="from"
                      value={searchDateFrom}
                      onChange={(e) => {
                        const value = e.target.value;
                        const year = value.split("-")[0];

                        // Check if year has 4 digits
                        if (year.length === 4 || value === "") {
                          setSearchDateFrom(value);
                          setonPageChange(1);
                        }
                      }}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="num me-2">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      placeholder="to"
                      value={searchDateTo}
                      onChange={(e) => {
                        const value = e.target.value;
                        const year = value.split("-")[0];

                        // Allow only if year is 4 digits or input is empty
                        if (year.length === 4 || value === "") {
                          setSearchDateTo(value);
                          setonPageChange(1);
                        }
                      }}
                    />
                  </div>
                </div>

                {/* <div className="col-md-3">
                  <label className="form-label">Start Time</label>
                  <DatePicker
                    selected={searchStartTime}
                    onChange={(date) => {
                      setSearchStartTime(date);
                      setonPageChange(1);
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Start Time"
                    dateFormat="h:mm aa" // 12-hour format
                    className="form-control"
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">End Time</label>
                  <DatePicker
                    selected={searchEndTime}
                    onChange={(date) => {
                      setSearchEndTime(date);
                      setonPageChange(1);
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="End Time"
                    dateFormat="h:mm aa"
                    className="form-control"
                  />
                </div> */}
              </div>
            </div>
          </div>
          <div className="row align-items-end mb-3">
            <div className="col-12 mb-2">
              <div className="row">
                <div className="col-lg-3 mb-2">
                  <Form.Label>Select Product </Form.Label>
                  <Select
                    isSearchable
                    options={product}
                    value={productCategory}
                    placeholder="Select Category"
                    onChange={(e) => {
                      setProductCategory(e);
                    }}
                    classNamePrefix="searchProduct"
                  />
                </div>
                <div className="col-lg-3 mb-2">
                  <Form.Label>Customer Name</Form.Label>
                  <Form.Control
                    placeholder="Enter Customer Name"
                    type="text"
                    className="form-control"
                    id=""
                    value={searchCustomer}
                    onChange={(e) => {
                      setSearchCustomer(e.target.value);
                    }}
                  />
                </div>

                <div className="col-lg-3 mb-2">
                  <Form.Label>Customer Contact No</Form.Label>
                  <Form.Control
                    placeholder="Enter Customer Contact No"
                    type="text"
                    className="form-control"
                    id=""
                    value={searchCustomerContact}
                    onChange={(e) => {
                      setSearchCustomerContact(e.target.value);
                    }}
                  />
                </div>
                <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
                  <div className="Search me-2">
                    <Form.Label>Search</Form.Label>
                    <Button
                      type="button"
                      onClick={getDataAll}
                      className="btn btn-search"
                    >
                      <img src={search1} className="search" alt="" />
                    </Button>
                  </div>
                </div>
                <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
                  <div className="Search-1">
                    <Form.Label>Reset</Form.Label>
                    <button
                      type="button"
                      onClick={() => {
                        setSearch("");
                        setSearchCustomerContact("");
                        setSearchDateFrom("");
                        setProductCategory("");
                        setSearchDateTo("");
                        setSearchEndTime("");
                        setSearchStartTime("");
                        setSearchCustomer("");
                        setReset(!reset);
                      }}
                      className="btn btn-reset"
                    >
                      Reset
                    </button>
                  </div>
                </div>
                <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
                  <Form.Label>Download Excel</Form.Label>
                  <div>
                    <button
                      className="btn btn-success mt-2"
                      type="button"
                      onClick={HandleDownload}
                    >
                      Excel
                      <FontAwesomeIcon
                        icon="fa-solid fa-file-lines"
                        className="ms-2"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Order Date </th>
              <th>Order details</th>
              {/* <th>Store details</th> */}
              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => (
              <tr key={index}>
                <td className="order-date">
                  <div className="order-id">
                    {calculateTimeAgo(item?.createdAt)}
                  </div>
                  <div className="order-info">
                    <span>
                      {new Date(item?.createdAt).toISOString().split("T")[0]}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{formatTimeInIST(item?.createdAt)} IST</span>
                  </div>
                </td>

                {/* Owner Details */}
                <td className="order-details">
                  <div className="order-id text-highlight">
                    {item?.invoice_no}
                  </div>
                  <div className="order-info">
                    <span>
                      <b>Buyer Name</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span className="text-highlight">{item?.User?.name}</span>
                  </div>
                  <div className="order-info">
                    <span className="order-info">{item?.User?.contact_no}</span>
                  </div>

                  <div className="order-info">
                    <span>{item?.Payment_Type?.name}</span>
                  </div>

                  {/* <div className="order-info">
                    <span>{item?.user?.type}</span>
                  </div> */}
                </td>

                {/* Store Details */}
                {/* <td className="order-details">
                  <div className="order-info">
                    <span className="text-highlight">
                      {item?.Store_Detail?.store_name}
                    </span>
                  </div>
                  <div className="order-info">
                    <span>{item?.Store_Detail?.legal_name}</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.Store_Detail?.website}</span>
                  </div>
                </td> */}

                <td className="order-details">
                  {item?.Product_Order_Details?.map((product) => (
                    <>
                      <div className="text-highlight">
                        <span>
                          <b>Product Name</b>
                        </span>
                        :<span>{product?.Product?.name}</span>
                      </div>
                      <div className="order-info">
                        <span>
                          <b>Category Name</b>
                        </span>
                        :<span>{product?.Product?.p_category?.name} </span>
                      </div>
                    </>
                  ))}
                  <div></div>
                  <div className=" mt-3">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        setShowDetails({
                          show: item?.id,
                          data: item?.Product_Order_Details,
                        })
                      }
                    >
                      View All Details
                    </Button>
                  </div>
                </td>

                  <td className="order-details">
                  <div className="order-id">
                    <span>
                      <b>Total SubTotal</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span>
                      {item.Exchange_Rate?.symbol || "₹"}{" "}
                      {Number(item?.total_selling_price).toFixed(2)} /-
                    </span>
                  </div>
                  {/* <div className="order-id">
                    <span>Packing Charges</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.packing_charges} /-</span>
                  </div> */}
                  <div className="order-id">
                    <span>
                      <b>Delivery Charges</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span> {item.Exchange_Rate?.symbol || "₹"}{" "}{Number(item?.delivery_charges).toFixed(2)} /-</span>
                  </div>
                  {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                  <div className="order-id">
                    <span>
                      <b>Coupon Discount</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span> {item.Exchange_Rate?.symbol || "₹"}{" "}{Number(item?.total_coupon_discount).toFixed(2)} /-</span>
                  </div>
                  {/* <div className="order-id">
                    <span>Refer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.refer_discount} /-</span>
                  </div> */}
                  <div className="order-id">
                    <span>
                      <b>Total Tax</b>
                    </span>
                  </div>
                  <div className="order-info">
                    <span> {item.Exchange_Rate?.symbol || "₹"}{" "}{Number(item?.total_tax).toFixed(2)} /-</span>
                  </div>
                  <div className="order-id">
                    <span>
                      <b>Grand Total</b>
                    </span>
                  </div>
                  <div className="text-highlight">
                    <span> {item.Exchange_Rate?.symbol || "₹"}{" "}{Number(item?.total_amount).toFixed(2)} /-</span>
                  </div>
                </td>

                <td>
                  {item?.Store_Detail?.s_category_id == 1 ? (
                    <>
                      <div className="order-info">
                        <p className="status-holder shipped">
                          {item?.Restaurant_Service?.name}
                        </p>
                      </div>

                      {item?.service_id == ServiceIds.Delivery ? (
                        <>
                          <div className="text-highlight">
                            <span>
                              {item?.User_Address?.first_name}{" "}
                              {item?.User_Address?.last_name}
                            </span>
                          </div>

                         <div className="order-info">
                      <strong> Shipping Address : </strong> <br></br>
                      
                      <span>{item?.User_Address?.building}, </span>
                      <span>{item?.User_Address?.apartment} ,</span>
                      <span>{item?.User_Address?.street}, </span>
                      <span>{item?.User_Address?.area}, </span>
                      <span>{item?.User_Address?.direction}, </span>
                      <br></br>
                      <strong> Billing Address : </strong> <br></br>
                     
                      <span>{item?.billing_user_address?.building}, </span>
                      <span>{item?.billing_user_address?.apartment} ,</span>
                      <span>{item?.billing_user_address?.street}, </span>
                      <span>{item?.billing_user_address?.area}, </span>
                      <span>{item?.billing_user_address?.direction}, </span>
                    </div>
                          <div className="order-info">
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail
                                  ?.Country?.name
                              }{" "}
                              ,
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail?.State
                                  ?.name
                              }
                              ,{" "}
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail?.City
                                  ?.name
                              }{" "}
                              ,
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail?.Area
                                  ?.name
                              }
                              ,{" "}
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail
                                  ?.Pincode?.name
                              }
                              ,{" "}
                            </span>
                          </div>
                          <div className="order-info">
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail
                                  ?.Country?.name
                              }{" "}
                              ,
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail?.State
                                  ?.name
                              }
                              ,{" "}
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail?.City
                                  ?.name
                              }{" "}
                              ,
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail?.Area
                                  ?.name
                              }
                              ,{" "}
                            </span>
                            <span>
                              {
                                item?.User_Address?.Users_Address_Detail
                                  ?.Pincode?.name
                              }
                              ,{" "}
                            </span>
                          </div>
                          <div className="order-info">
                            <span>{item?.User_Address?.address_type}</span>
                          </div>
                          <div className="text-highlight">
                            <span>{item?.User_Address?.contact_no} </span>
                          </div>
                        </>
                      ) : item?.service_id == ServiceIds.DineIn ? (
                        <>
                          <div className="order-info">
                            {" "}
                            <span> Table No :-</span>{" "}
                          </div>
                          <div className="text-highlight">
                            <span>{item?.table_no}</span>
                          </div>
                        </>
                      ) : item?.service_id == ServiceIds.RoomService ? (
                        <>
                          <div className="order-info">
                            {" "}
                            <span> Room No :-</span>{" "}
                          </div>
                          <div className="text-highlight">
                            <span>{item?.room_no}</span>
                          </div>
                        </>
                      ) : (
                        <></>
                      )}{" "}
                    </>
                  ) : (
                    <>
                      <div className="text-highlight">
                        <span>
                          {item?.User_Address?.first_name}{" "}
                          {item?.User_Address?.last_name}
                        </span>
                      </div>
                       <div className="order-info">
                      <strong> Shipping Address : </strong> <br></br>
                      
                      <span>{item?.User_Address?.building}, </span>
                      <span>{item?.User_Address?.apartment} ,</span>
                      <span>{item?.User_Address?.street}, </span>
                      <span>{item?.User_Address?.area}, </span>
                      <span>{item?.User_Address?.direction}, </span>
                      <br></br>
                      <strong> Billing Address : </strong> <br></br>
                     
                      <span>{item?.billing_user_address?.building}, </span>
                      <span>{item?.billing_user_address?.apartment} ,</span>
                      <span>{item?.billing_user_address?.street}, </span>
                      <span>{item?.billing_user_address?.area}, </span>
                      <span>{item?.billing_user_address?.direction}, </span>
                    </div>
                      <div className="order-info">
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Country
                              ?.name
                          }{" "}
                          ,
                        </span>
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.State
                              ?.name
                          }
                          ,{" "}
                        </span>
                        <span>
                          {item?.User_Address?.Users_Address_Detail?.City?.name}{" "}
                          ,
                        </span>
                        <span>
                          {item?.User_Address?.Users_Address_Detail?.Area?.name}
                          ,{" "}
                        </span>
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Pincode
                              ?.name
                          }
                          ,{" "}
                        </span>
                      </div>
                      <div className="order-info">
                        <span>{item?.User_Address?.address_type}</span>
                      </div>
                      <div className="text-highlight">
                        <span>{item?.User_Address?.contact_no} </span>
                      </div>
                    </>
                  )}
                </td>
                <td>{item?.Order_status?.name}</td>
                <td>
                  {item?.order_status_id ===
                  OrderStatusIds.OrderUnderQualityCheck ? (
                    <div className="my-1">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          ChangeOrderStatus(item?.id, OrderStatusIds.Pickup)
                        }
                      >
                        Send PickUp
                      </Button>
                    </div>
                  ) : item?.order_status_id === OrderStatusIds.Pickup ? (
                    <div className="my-1">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          ChangeOrderStatus(item?.id, OrderStatusIds.Delivered)
                        }
                      >
                        Send Delivered
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                    >
                      Print Invoice
                    </Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>
      <AssignOffCanvance
        handleClose={() => {
          setShowAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowAssign({ show: 0, data: {} })}
        show={showAssign?.show}
        data={showAssign?.data}
      />
      <AssignReturnOffCanvance
        handleClose={() => {
          setShowReturnAssign({ show: 0, data: {} });
          getDataAll();
        }}
        setShow={() => setShowReturnAssign({ show: 0, data: {} })}
        show={showReturnAssign?.show}
        data={showReturnAssign?.data}
      />
      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />
    </section>
  );
}

export default SentTable;
